module.exports = __webpack_public_path__ + "img/zhongyi.4f5347f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhongyi.png
// module id = +cOp
// module chunks = 0